var $fd654b32a057aa1f$exports = {};
$fd654b32a057aa1f$exports = {
    "pending": `pendente`
};


export {$fd654b32a057aa1f$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
